export { default } from './Flash';
